import createDataContext from './createDataContext';
import * as actions from './actions/notificationActions';
import { reducer, initialState } from './reducers/notificationReducer';

export const { Context: NotificationContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
